import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function PublisherReport() {        
    const { doFetch } = useFetch()
    const columns = getColumns()
    
    return (
        <Table 
            columns={columns} 
            getData={async (fromDate, toDate) => {
                const res = await doFetch('/data/total-transactions-by-affiliate', {
                    fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
                })
                const data = await res.json()
                
                for(const d of data) {
                    d.conversionRate = d.totalTransactions / d.totalClicks * 100
                    d.roas = d.totalOrderAmount / d.totalCommission
                    d.cpc = d.totalCommission / d.totalClicks
                    d.epc = d.totalOrderAmount / d.totalClicks
                }

                return data
            }}
            title='Publisher report'
            defaultSort='totalOrderAmount'
        />)
}

